/**
 * Studio TabBar source of truth.
 *
 * This file is intentionally pure data so unit tests can pin the Studio
 * primary navigation without importing TanStack Router or React.
 */

import { Cpu, Wrench, FileCode2, BookOpen, MessageSquare } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export interface StudioTab {
  readonly label: string;
  readonly path: string;
  readonly icon: LucideIcon;
}

export const STUDIO_TABS: readonly StudioTab[] = [
  { label: 'Models', path: '/studio', icon: Cpu },
  { label: 'Tools', path: '/studio/tools', icon: Wrench },
  { label: 'Functions', path: '/studio/functions', icon: FileCode2 },
  { label: 'Skills', path: '/studio/skills', icon: BookOpen },
  { label: 'Prompts', path: '/studio/prompts', icon: MessageSquare },
] as const;
